import React, { useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { Table, Tag, Tooltip } from "antd";
import UserBadgeTag from "../shared/UserBadgeTag";
import TopupPackageTag from "../shared/TopupPackageTag";

import { formatDateTime, getRelativeTimeFromNow } from "../../helpers/date";

const SubAccountFilter = ({
  masterAccount,
  selectedRowKeys,
  onSelectRows,
  name,
  loading
}) => {
  const table = [
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      ellipsis: true,
      sorter: {
        compare: (a, b) => a.username.length - b.username.length,
        multiple: 1,
      },
      sortDirections: ["descend", "ascend"],
      render: (text, row) => (
        <Link to={`/sub-account/${row._id}`}>{text}</Link>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      ellipsis: true,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Last Active Date",
      dataIndex: "lastDateActive",
      key: "lastDateActive",
      render: (text) => (text === null || text === undefined ? "-" : <Tooltip placement="topLeft" title={formatDateTime(text)}>
        {getRelativeTimeFromNow(text)}
      </Tooltip>),
    },
    {
      title: "Registered Date",
      dataIndex: "_created_at",
      key: "_created_at",
      render: (text) => (text ? formatDateTime(text) : "-"),
      sorter: {
        compare: (a, b) => a.createdAt - b.createdAt,
        multiple: 3,
      },
    },
  ];

  const userTable = [
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      sorter: {
        compare: (a, b) => a.username.length - b.username.length,
        multiple: 1,
      },
      sortDirections: ["descend", "ascend"],
      render: (text, row) => (
        <>
          <a href={`/user/${row.id}`}>{text}</a>
          {row.inheritsFeatures && (
            <Tag color="blue" style={{ marginLeft: 8 }}>
              Inheriting
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Registered Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (text ? formatDateTime(text) : "-"),
      sorter: {
        compare: (a, b) => a.totalTopup - b.totalTopup,
        multiple: 3,
      },
    },
  ];

  return (
    <div className="table">
      {name === "user" ? (
        <Table
          rowKey="id"
          rowSelection={{
            selectedRowKeys,
            onChange: onSelectRows,
            getCheckboxProps: (subAccount) => ({
              disabled: !!subAccount.deactivatedAt,
            }),
          }}
          className="table-section"
          columns={userTable}
          dataSource={masterAccount}
          pagination={false}
          scroll={{ x: true }}
          loading={loading}
        />
      ) : (
        <Table
          rowKey="objectId"
          rowSelection={{ selectedRowKeys, onChange: onSelectRows }}
          className="table-section"
          columns={table}
          dataSource={masterAccount}
          pagination={false}
          scroll={{ x: 1000, y: 600 }}
          loading={loading}
        />
      )}
    </div>
  );
};

export default SubAccountFilter;
